// src/pages/sow-template/SectionEditorPanel.jsx
import PropTypes from "prop-types";
import { FormField, Input, SurfaceCard } from "../../shared/ui";

export default function SectionEditorPanel({ tpl, section, onFieldChange, editorRef }) {
  return (
    <SurfaceCard>
      <div className="flex items-center justify-between gap-3 mb-4">
        <h2 className="text-base font-semibold text-ink">Editor{section ? ` — ${section.title}` : ""}</h2>
        {tpl?.id && <span className="text-xs text-muted">Template #{tpl.id}</span>}
      </div>

      {!tpl || !section ? (
        <p className="text-sm text-muted">Select a section above to edit it.</p>
      ) : (
        <div className="flex flex-col gap-3">
          <div className="grid grid-cols-3 gap-3">
            <div className="col-span-2">
              <FormField label="Section Title">
                <Input
                  value={section.title}
                  onChange={(e) => onFieldChange(section.key, { title: e.target.value })}
                  placeholder="Section title (e.g., '3. Scope of Services')"
                />
              </FormField>
            </div>
            <FormField label="Key">
              <Input value={section.key} disabled />
            </FormField>
          </div>

          <FormField label="Content">
            <textarea
              ref={editorRef}
              className="shui-input"
              style={{ minHeight: 260 }}
              value={section.content_template || ""}
              onChange={(e) => onFieldChange(section.key, { content_template: e.target.value })}
              placeholder="Write template text here. Use placeholders like <Client Name> or {{project_name}}"
            />
          </FormField>

          <FormField label="Prompt Hint" helperText="Optional -- guidance for AI drafting">
            <Input
              value={section.prompt_hint || ""}
              onChange={(e) => onFieldChange(section.key, { prompt_hint: e.target.value })}
            />
          </FormField>
        </div>
      )}
    </SurfaceCard>
  );
}

SectionEditorPanel.propTypes = {
  tpl: PropTypes.object,
  section: PropTypes.object,
  onFieldChange: PropTypes.func.isRequired,
  editorRef: PropTypes.object.isRequired,
};
